import PolicyPage from "./PolicyPage";

export default function Delivery() {
    return <PolicyPage name="delivery" />;
}
